import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { shade, tint } from 'polished';
import { AddCircleIcon, InfoIcon, CheckCircleIcon, WarningIcon } from '@origin-digital/icon';
import { Box } from '@origin-digital/layout';
import { Markdown } from '../Text/Markdown';
import { Colors } from '../../consts/palette.const';
import { mapColorLabelToHex } from '../../helpers/colorStyle.helper';
import { LineHeights, FontSizes, FontWeights } from '../../consts/metrics.const';
import { sansSerif } from '../../helpers';
var AlertBoxColors = {
  BASIC: 'grey',
  ERROR: 'red',
  INFO: 'blue',
  SUCCESS: 'green',
  WARNING: 'red'
};
var AlertBoxIcons = {
  BASIC: InfoIcon,
  ERROR: AddCircleIcon,
  INFO: InfoIcon,
  SUCCESS: CheckCircleIcon,
  WARNING: WarningIcon
};
export var AlertBoxTypes = {
  BASIC: 'basic',
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning'
};

var getIconType = function getIconType(alertType) {
  var type = alertType ? alertType.toUpperCase() : '';
  return AlertBoxIcons[type] || AlertBoxIcons.INFO;
};

export var getAlertColorLabel = function getAlertColorLabel(alertType) {
  var type = alertType ? alertType.toUpperCase() : '';
  return AlertBoxColors[type] || AlertBoxColors.INFO;
};

var clearOrTint = function clearOrTint(color, percentage) {
  return color === Colors.TRANSPARENT ? 'transparent' : tint(percentage, color);
};

var Wrapper = styled.div.attrs({
  'data-id': function dataId(props) {
    return props['data-id'];
  }
}).withConfig({
  displayName: "AlertBox__Wrapper",
  componentId: "vs70ra-0"
})(["display:flex;margin:0;padding:16px;border:solid 1px ", ";background-color:", ";"], function (_ref) {
  var color = _ref.color;
  return clearOrTint(color, 0.16);
}, function (_ref2) {
  var color = _ref2.color;
  return clearOrTint(color, 0.08);
});
var AlertBody = styled(function (_a) {
  var fontColor = _a.fontColor,
      rest = __rest(_a, ["fontColor"]);

  return React.createElement(Box, rest);
}).withConfig({
  displayName: "AlertBox__AlertBody",
  componentId: "vs70ra-1"
})(["flex-grow:1;color:", ";&& *:not(button){color:", ";}button *{color:inherit;}"], function (_ref3) {
  var fontColor = _ref3.fontColor;
  return shade(0.48, fontColor);
}, function (_ref4) {
  var fontColor = _ref4.fontColor;
  return shade(0.48, fontColor);
});
var AlertHeading = styled.h3.withConfig({
  displayName: "AlertBox__AlertHeading",
  componentId: "vs70ra-2"
})(["margin:0 0 16px;", ";font-weight:", ";font-size:", "px;line-height:", "px;color:", ";"], sansSerif, FontWeights.MEDIUM, FontSizes.BODY, LineHeights.BODY, function (_ref5) {
  var color = _ref5.color;
  return shade(0.48, color);
});
var AlertMessage = styled.div.withConfig({
  displayName: "AlertBox__AlertMessage",
  componentId: "vs70ra-3"
})(["", ";font-weight:", ";font-size:", "px;line-height:", "px;color:", ";"], sansSerif, FontWeights.REGULAR, FontSizes.BODY, LineHeights.BODY, function (_ref6) {
  var color = _ref6.color;
  return shade(0.48, color);
});

var AlertBox = function AlertBox(_ref7) {
  var heading = _ref7.heading,
      message = _ref7.message,
      children = _ref7.children,
      type = _ref7.type,
      _transparent = _ref7._transparent,
      dataId = _ref7['data-id'],
      markdown = _ref7.markdown;
  var colorLabel = getAlertColorLabel(type);
  var colorHex = mapColorLabelToHex(colorLabel);
  var baseColor = _transparent ? Colors.TRANSPARENT : colorHex;
  var IconSkin = getIconType(type);
  var Icon = styled(IconSkin).withConfig({
    displayName: "AlertBox__Icon",
    componentId: "vs70ra-4"
  })(["min-width:24px;margin-right:10px;", ";"], IconSkin.displayName === 'AddCircleIcon' ? 'transform: rotate(45deg);' : '');
  return React.createElement(Wrapper, {
    color: baseColor,
    "data-id": dataId
  }, React.createElement(Icon, {
    accessibilityLabel: "".concat(type, " icon"),
    color: colorLabel
  }), React.createElement(AlertBody, {
    fontColor: colorHex
  }, heading && React.createElement(AlertHeading, {
    color: colorHex
  }, React.createElement(Markdown, {
    size: "sm",
    markdown: markdown
  }, heading)), children ? children : React.createElement(AlertMessage, {
    color: colorHex
  }, React.createElement(Markdown, {
    size: "sm",
    markdown: markdown
  }, message))));
};

AlertBox.propTypes = {
  message: PropTypes.string,
  heading: PropTypes.string,
  type: PropTypes.oneOf(_Object$values(AlertBoxTypes)),
  _transparent: PropTypes.bool,
  'data-id': PropTypes.string,
  children: PropTypes.object,
  markdown: PropTypes.bool
};
AlertBox.displayName = 'alertBox';
AlertBox.defaultProps = {
  type: AlertBoxTypes.INFO,
  _transparent: false,
  'data-id': AlertBox.displayName,
  markdown: false
};
export { AlertBox };